import React from "react";
import { useTranslation } from "react-i18next";
import { AutoCompleteInput } from "components/form/inputs/autoCompleteInput.component";
import { characterCounter } from "components/Typography/text.styled";
import { Roles } from "config/rolesMock";
import { RecruitFormData } from "./gigFormModal.component";
import { SimpleRow } from "../../organizationalStructure/organizationalStructure.styled";
import { WorkerCounter } from "./workerCounter/workerCounter.component";
type Props = {
  setFormData: React.Dispatch<React.SetStateAction<RecruitFormData>>;
  formData: RecruitFormData;
};

export const GigRole: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <SimpleRow style={{ justifyContent: "flex-start" }}>
        <AutoCompleteInput
          label={t("CreateShift.RoleWanted")}
          inputValue={props.formData.role}
          onChange={(val: string) =>
            props.setFormData({
              ...props.formData,
              role: val,
            })
          }
          selections={Roles.map((mockedRole) => t(mockedRole, { ns: "roles" }))}
        />
        <WorkerCounter
          value={props.formData.amountOfWorkers}
          onChange={(val: number) =>
            props.setFormData({
              ...props.formData,
              amountOfWorkers: val,
            })
          }
        />
      </SimpleRow>
      {characterCounter(24, props.formData.role)}
    </>
  );
};
